import { format } from 'date-fns';
import { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';

import { useGetTimelineAlerts } from '@/modules/home/apiHooks';
import { TimelineAlert } from '@/modules/home/components/TimeLine/TimelineAlerts/TimelineAlert';
import { useHomePageContext } from '@/modules/home/context';
import { Loading } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

import ExleminationMark from '~/images/shared/FilledExleminationMark.svg';

const TimelineAlerts = (): ReactElement => {
  const { t } = useTranslation('common');
  const {
    state: { date },
  } = useHomePageContext();
  const [selectedAsset] = useStore((store) => store?.asset);

  const { data, fetchNextPage, hasNextPage } = useGetTimelineAlerts({
    date: format(date, 'yyyy-MM-dd'),
    entityId: selectedAsset?.id,
    pageNumber: 1,
    pageSize: 10,
  });
  return data?.pages && data?.pages[0]?.items?.length > 0 ? (
    <InfiniteScroll
      loadMore={() => fetchNextPage()}
      hasMore={hasNextPage}
      loader={<Loading />}
      useWindow={false}
      // getScrollParent={() => (ref && 'current' in ref ? ref?.current : null)}
      className='mt-16 flex flex-col gap-16'
    >
      {data?.pages?.map((page, i) => (
        <Fragment key={i}>
          {page?.items?.map((alert) => (
            <Fragment key={alert.id}>
              <TimelineAlert alert={alert} />
              <div className='h-px w-full bg-grey-200 bg-opacity-5' />
            </Fragment>
          ))}
        </Fragment>
      ))}
    </InfiniteScroll>
  ) : (
    <EmptyCard
      message={t('no-alerts')}
      directiveMessage={t('alerts-shown-when-report')}
      vector={
        <span className='text-primary-60'>
          <ExleminationMark />
        </span>
      }
      variant='icon'
      classeName='text-primary-60 text-40 text-center px-7'
    />
  );
};
export { TimelineAlerts };
